import React from "react";
import { Banner, Categories } from "../../components";

const Home = () => {
  return (
    <>
      <Banner />
      <Categories />
    </>
  );
};

export default Home;
